import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'dialogue',
        loadChildren: () => import('./pages/dialogue/dialogue.module').then(m => m.DialogueModule)
    },
    {
        path: 'pc-dialogue',
        loadChildren: () => import('./pages/pc-dialogue/pc-dialogue.module').then(m => m.PcDialogueModule)
    },
    {
        path: 'not-auth-dialogue',
        loadChildren: () => import('./pages/not-auth-dialogue/not-auth-dialogue.module').then(m => m.NotAuthDialogueModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'pc-login',
        loadChildren: () => import('./pages/pc-login/pc-login.module').then(m => m.PcLoginModule)
    },
    {
        path: 'user-data',
        loadChildren: () => import('./pages/user-data/user-data.module').then(m => m.UserDataModule)
    },
    {
        path: '',
        redirectTo: '/dialogue',
        pathMatch: 'full'
    }
]
